/* global Shopify, publish, PUB_SUB_EVENTS, aomTrack */
const widget = document.getElementById("aom-bundle-widget");
const lang = widget?.dataset.aomProductLang;

// window.aomTrack (from aom-analytics.js) may not exist yet when this module
// runs on init — referencing the bare global would throw a ReferenceError.
// Route all analytics through this wrapper, which no-ops until it's ready
// (same drop-if-not-ready behaviour aomTrack itself has when gtag is missing).
function aomTrackSafe() {
  if (typeof window !== "undefined" && typeof window.aomTrack === "function") {
    window.aomTrack.apply(null, arguments);
  }
}

const translationMap = {
  en: {
    savings: "You save: ",
    save: "Save",
    each: "each",
    hr: "hr",
    mins: "mins",
    secs: "secs",
  },
  da: {
    // Denmark
    savings: "Du sparer: ",
    save: "Spar",
    each: "pr. stk.",
    hr: "t",
    mins: "min",
    secs: "sek",
  },
  sv: {
    // Sweden
    savings: "Du sparar: ",
    save: "Spara",
    each: "styck",
    hr: "tim",
    mins: "min",
    secs: "sek",
  },
  nb: {
    // Norway
    savings: "Du sparer: ",
    save: "Spar",
    each: "per stk",
    hr: "t",
    mins: "min",
    secs: "sek",
  },
  fi: {
    // Finland
    savings: "Säästät: ",
    save: "Säästä",
    each: "/ kpl",
    hr: "t",
    mins: "min",
    secs: "s",
  },
  nl: {
    // Netherlands
    savings: "Je bespaart: ",
    save: "Bespaar",
    each: "per stuk",
    hr: "u",
    mins: "min",
    secs: "sec",
  },
  fr: {
    // France / Belgium / Switzerland
    savings: "Vous économisez : ",
    save: "Économisez",
    each: "chacun",
    hr: "h",
    mins: "min",
    secs: "s",
  },
  es: {
    // Spain
    savings: "Ahorras: ",
    save: "Ahorra",
    each: "cada uno",
    hr: "h",
    mins: "min",
    secs: "s",
  },
  de: {
    // Germany / Austria / Belgium / Switzerland
    savings: "Sie sparen: ",
    save: "Sparen Sie",
    each: "pro Stück",
    hr: "Std",
    mins: "Min",
    secs: "Sek",
  },
  it: {
    // Italy / Switzerland
    savings: "Risparmi: ",
    save: "Risparmia",
    each: "cadauno",
    hr: "h",
    mins: "min",
    secs: "s",
  },
  ga: {
    // Ireland (Irish)
    savings: "Sábhálann tú: ",
    save: "Sábháil",
    each: "an ceann",
    hr: "uair",
    mins: "nóim",
    secs: "soic",
  },
  is: {
    // Iceland
    savings: "Þú sparar: ",
    save: "Spara",
    each: "hver",
    hr: "klst",
    mins: "mín",
    secs: "sek",
  },
  el: {
    // Greece
    savings: "Κερδίζετε: ",
    save: "Εξοικονομήστε",
    each: "το καθένα",
    hr: "ώρες",
    mins: "λεπτά",
    secs: "δευτ.",
  },
  "pt-BR": {
    savings: "Você economiza: ",
    save: "Economize",
    each: "cada",
    hr: "h",
    mins: "min",
    secs: "s",
  },
  pt: {
    // Portugal
    savings: "poupa: ",
    save: "Poupe",
    each: "cada",
    hr: "h",
    mins: "min",
    secs: "s",
  },
};

const currentTranslation = translationMap[lang] || translationMap.en;
const productVariants = JSON.parse(
  document.getElementById("product-variants-json").textContent,
);
// {{ product.variants | json }} serialises base-currency prices and ignores
// Markets contextual pricing, so overlay the per-market price map rendered by Liquid.
try {
  const priceCtxEl = document.getElementById("aom-bundle-price-ctx");
  if (priceCtxEl) {
    const priceCtx = JSON.parse(priceCtxEl.textContent || "{}");
    productVariants.forEach((variant) => {
      const ctx = priceCtx[variant.id];
      if (ctx) {
        variant.price = ctx[0];
        variant.compare_at_price = ctx[1] || null;
      }
    });
  }
} catch (e) {}
const bundleStyle = widget?.dataset.aomBundleStyle || 'DEFAULT';

// Listeners that attach after this script's initial dispatch (e.g. the
// floating add-to-cart bar, which waits on customElements.whenDefined) would
// otherwise miss the starting price/quantity/images entirely. Cache the last
// detail and answer late-comers who ask for it via 'aom:savings:request'.
let _aomLastSavingsDetail = null;
function dispatchSavings(detail) {
  _aomLastSavingsDetail = detail;
  document.dispatchEvent(new CustomEvent('aom:savings', { detail: detail }));
}
document.addEventListener('aom:savings:request', function () {
  if (_aomLastSavingsDetail) {
    document.dispatchEvent(new CustomEvent('aom:savings', { detail: _aomLastSavingsDetail }));
  }
});

const activeWrappers = document.querySelectorAll(".aom-discount-wrapper");
activeWrappers.forEach((wrapper) => {
  const { quantity, discountValue, discountType } = wrapper.querySelector(
    ".aom-discount-radio",
  ).dataset;
  updatePrices(wrapper, parseInt(quantity), discountValue, discountType);
});

function findMatchingVariant(options) {
  return productVariants.find((variant) =>
    variant.options.every((value, idx) => value === options[idx]),
  );
}

function updatePrices(wrapper, quantity, discountValue, discountType) {
  const groupedOptions = getSelectedOptionsValueFromActiveTier(wrapper);
  const matchingVariants = groupedOptions.map(findMatchingVariant);
  if (matchingVariants.some((v) => !v)) return;

  // Baseline (compare-at if higher; else price) => for "original" + savings math
  const baselineTotal = matchingVariants
    .map(getBasePriceCents)
    .reduce((a, b) => a + b, 0);

  // Current total (actual unit price) => the starting point for discounts
  const currentTotal = matchingVariants
    .map(getCurrentPriceCents)
    .reduce((a, b) => a + b, 0);

  let discountedTotal = currentTotal;

  if (discountType === "PERCENTAGE_DISCOUNT") {
    const pct = Math.max(0, Math.min(100, parseFloat(discountValue || 0)));
    const multiplier = (100 - pct) / 100;
    discountedTotal = currentTotal * multiplier;
  }
  // else NO_DISCOUNT: discountedTotal stays = currentTotal

  const savings = Math.max(0, baselineTotal - discountedTotal);

  const images = [];
  const titles = matchingVariants.map((v) => v.title);
  matchingVariants.forEach((v) => {
    const src = getImageSrc(getVariantFeaturedImage(v));
    if (src && images.indexOf(src) === -1) images.push(src);
  });
  // Reuse the already-rendered (and already-translated) offer title instead
  // of re-deriving a "N items" string in JS.
  const label = wrapper.querySelector('[data-aom-offer-title]')?.textContent.trim() || null;

  // Notify card-banner.js / aom-product-compare-v2 of price+savings for the active tier
  if (wrapper.querySelector('.aom-discount-radio:checked')) {
    dispatchSavings({ saveCents: savings, priceCents: discountedTotal, origCents: baselineTotal, quantity: quantity, images: images, titles: titles, label: label });
  }

  // Render totals
  wrapper.querySelector('[data-role="total-price"]').innerText =
    formatMoney(discountedTotal);

  const savingsEl = wrapper.querySelector('[data-role="savings"]');
  const originalEl = wrapper.querySelector('[data-role="original-price"]');

  if (savings > 0) {
    savingsEl.innerText = `${currentTranslation.savings}${formatMoney(savings)}`;
    originalEl.innerText = formatMoney(baselineTotal);
    originalEl.style.display = ""; // ensure visible if previously hidden
  } else {
    // Clear when no savings
    savingsEl.innerText = "";
    originalEl.innerText = "";
    // optional: hide if you prefer no empty line
    // originalEl.style.display = "none";
  }
}

function getBasePriceCents(variant) {
  const price = Number(variant.price || 0);
  const compare = Number(variant.compare_at_price || 0);
  // Only use compare-at if it’s set and actually higher than price
  return compare > price ? compare : price;
}

function getCurrentPriceCents(variant) {
  // The actual price the customer pays BEFORE any bundle discount
  return Number(variant.price || 0);
}

function escapeCssSelector(value) {
  if (window.CSS && typeof window.CSS.escape === 'function') {
    return window.CSS.escape(String(value));
  }
  return String(value).replace(/["\\]/g, '\\$&');
}

function restoreWindowScroll(x, y) {
  if (typeof window.scrollTo !== 'function') return;
  window.scrollTo(x, y);
  requestAnimationFrame(function () { window.scrollTo(x, y); });
  setTimeout(function () { window.scrollTo(x, y); }, 80);
  setTimeout(function () { window.scrollTo(x, y); }, 240);
}

function preserveWindowScroll(callback) {
  const x = window.scrollX || window.pageXOffset || 0;
  const y = window.scrollY || window.pageYOffset || 0;
  callback();
  restoreWindowScroll(x, y);
}

function getProductRoot() {
  return widget?.closest('product-info')
    || widget?.closest('[id^="shopify-section-"]')
    || document;
}

function resolveProductSectionId() {
  const productInfo = widget?.closest('product-info') || document.querySelector('product-info');
  if (productInfo?.dataset?.section) return productInfo.dataset.section;

  const section = widget?.closest('[id^="shopify-section-"]') || document.querySelector('[id^="shopify-section-template"]');
  if (section?.id) return section.id.replace(/^shopify-section-/, '');

  const dataSection = getProductRoot().querySelector?.('[data-section]');
  return dataSection?.dataset?.section || '';
}

function getVariantFeaturedMediaId(variant) {
  const media = variant?.featured_media || variant?.featuredMedia;
  return media?.id || variant?.featured_media_id || variant?.featured_image?.id || media || null;
}

function getVariantFeaturedImage(variant) {
  const media = variant?.featured_media || variant?.featuredMedia;
  return media?.preview_image
    || media?.previewImage
    || media?.image
    || variant?.featured_image
    || variant?.featuredImage
    || null;
}

function getImageSrc(image) {
  if (!image) return '';
  if (typeof image === 'string') return image;
  return image.src || image.url || image.originalSrc || image.transformedSrc || '';
}

function updateActiveGalleryImageFromVariant(variant) {
  const featuredImage = getVariantFeaturedImage(variant);
  const src = getImageSrc(featuredImage);
  if (!src) return false;

  const root = getProductRoot();
  const gallery = root.querySelector?.('media-gallery') || document.querySelector('media-gallery');
  const activeSlide = gallery?.querySelector?.('.product__media-item.is-active, [data-media-id].is-active')
    || root.querySelector?.('.product__media-item.is-active, [data-media-id].is-active')
    || gallery?.querySelector?.('.product__media-item, [data-media-id]')
    || root.querySelector?.('.product__media-item, [data-media-id]');
  const activeImage = activeSlide?.querySelector?.('img');

  if (!activeImage) return false;

  activeSlide.querySelectorAll('source[srcset]').forEach(function (source) {
    source.setAttribute('srcset', src);
  });
  activeImage.removeAttribute('srcset');
  activeImage.src = src;
  if (featuredImage.alt) activeImage.alt = featuredImage.alt;

  return true;
}

function updateMediaGalleryWithoutPageScroll(variant) {
  const mediaId = getVariantFeaturedMediaId(variant);
  if (!mediaId) return updateActiveGalleryImageFromVariant(variant);

  const root = getProductRoot();
  const gallery = root.querySelector?.('media-gallery') || document.querySelector('media-gallery');
  const sectionId = resolveProductSectionId();
  const activeMediaId = sectionId ? sectionId + '-' + mediaId : String(mediaId);
  const selectors = [
    '[data-media-id="' + escapeCssSelector(activeMediaId) + '"]',
    '[data-media-id="' + escapeCssSelector(mediaId) + '"]',
    '#Slide-' + escapeCssSelector(activeMediaId),
  ];

  const slide = selectors
    .map(function (selector) { return root.querySelector?.(selector) || document.querySelector(selector); })
    .find(Boolean);

  if (slide) {
    const mediaList = slide.closest('.product__media-list, [id^="Slider-Gallery"], .slider') || slide.parentElement;
    if (mediaList) {
      mediaList.querySelectorAll('[data-media-id]').forEach(function (item) {
        item.classList.remove('is-active');
      });
    }
    slide.classList.add('is-active');
    if (mediaList && typeof mediaList.scrollTo === 'function') {
      mediaList.scrollTo({ left: slide.offsetLeft, behavior: 'auto' });
    }
  }

  const thumbSelectors = [
    '[data-target="' + escapeCssSelector(activeMediaId) + '"]',
    '[data-target="' + escapeCssSelector(mediaId) + '"]',
    '#Thumbnail-' + escapeCssSelector(activeMediaId),
  ];
  const thumb = thumbSelectors
    .map(function (selector) { return root.querySelector?.(selector) || document.querySelector(selector); })
    .find(Boolean);

  if (thumb) {
    const thumbList = thumb.closest('.thumbnail-list, [id^="Slider-Thumbnails"], .slider') || thumb.parentElement;
    if (thumbList) {
      thumbList.querySelectorAll('button[aria-current="true"]').forEach(function (button) {
        button.removeAttribute('aria-current');
      });
    }
    const thumbButton = thumb.matches?.('button') ? thumb : thumb.querySelector?.('button');
    if (thumbButton) thumbButton.setAttribute('aria-current', 'true');
    if (thumbList && typeof thumbList.scrollTo === 'function') {
      thumbList.scrollTo({ left: thumb.offsetLeft, behavior: 'auto' });
    }
  }

  if (!slide && updateActiveGalleryImageFromVariant(variant)) {
    return true;
  }

  if (!slide && gallery && typeof gallery.setActiveMedia === 'function') {
    preserveWindowScroll(function () {
      gallery.setActiveMedia(activeMediaId, true);
    });
    return true;
  }

  return Boolean(slide || thumb);
}

function syncProductVariantInput(variant) {
  if (!variant) return;
  const root = getProductRoot();
  const inputs = Array.from(root.querySelectorAll(
    'form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] input[name="variant_id"], product-form input[name="id"]',
  ));

  Array.from(new Set(inputs)).forEach(function (input) {
    if (String(input.value) === String(variant.id)) return;
    input.value = variant.id;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
}

function updateProductPresentationForVariant(variant) {
  if (!variant) return;
  preserveWindowScroll(function () {
    updateMediaGalleryWithoutPageScroll(variant);
    syncProductVariantInput(variant);
  });
}

function formatMoney(cents) {
  // eslint-disable-next-line no-undef
  const { locale, currency } = Shopify;

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency.active,
  }).format(cents / 100);
}

function getSelectedOptionsValueFromActiveTier(selectedWrapper) {
  const result = [];
  const selects = selectedWrapper?.querySelectorAll("select");
  const optionsLength = productVariants[0].options.length;

  if (!selects || selects.length === 0) {
    return result;
  }

  const groupOf = Math.floor(selects.length / optionsLength);

  for (let i = 0; i < groupOf; i++) {
    const group = [];
    const remainder = i % groupOf;

    for (let j = 0; j < optionsLength; j++) {
      const selectIndex = remainder + j * groupOf;
      const optionIndex = selects[selectIndex].selectedIndex;
      const selectValue = selects[selectIndex]?.options?.[optionIndex]?.value;
      group.push(selectValue);
    }
    result.push(group);
  }

  return result;
}

function getVariantsSelectedCount(groupedOptions) {
  const result = {};

  if (!Array.isArray(groupedOptions) || groupedOptions.length === 0) {
    return result;
  }

  groupedOptions.forEach((group) => {
    const variant = findMatchingVariant(group);
    if (variant) {
      const variantId = variant.id;
      result[variantId] = (result[variantId] || 0) + 1;
    }
  });
  return result;
}

function getSelectedOptionsIdFromActiveTier(selectedWrapper, event) {
  const result = [];
  const selects = selectedWrapper.querySelectorAll("select");
  const optionsLength = productVariants[0].options.length;
  const groupOf = Math.floor(selects.length / optionsLength);

  const selectedSelectIndexRaw =
    Array.from(selects).findIndex((select) => select === event?.target);
  const selectedSelectIndex = selectedSelectIndexRaw >= 0 ? selectedSelectIndexRaw : 0;
  const remainder =
    selectedSelectIndex !== -1 ? selectedSelectIndex % groupOf : 0;

  for (let i = 0; i < optionsLength; i++) {
    const selectIndex = remainder + i * groupOf;
    const optionIndex = selects[selectIndex].selectedIndex;
    const selectValue =
      selects[selectIndex]?.options?.[optionIndex]?.dataset.optionValueId;
    result.push(selectValue);
  }

  return result;
}

function getSelectedOptionsValueFromEventGroup(selectedWrapper, event) {
  const result = [];
  const selects = selectedWrapper.querySelectorAll("select");
  const optionsLength = productVariants[0].options.length;
  const groupOf = Math.floor(selects.length / optionsLength);

  if (!selects.length || !optionsLength || !groupOf) return result;

  const selectedSelectIndexRaw =
    Array.from(selects).findIndex((select) => select === event?.target);
  const selectedSelectIndex = selectedSelectIndexRaw >= 0 ? selectedSelectIndexRaw : 0;
  const remainder = selectedSelectIndex % groupOf;

  for (let i = 0; i < optionsLength; i++) {
    const selectIndex = remainder + i * groupOf;
    const optionIndex = selects[selectIndex].selectedIndex;
    result.push(selects[selectIndex]?.options?.[optionIndex]?.value);
  }

  return result;
}

function getCartItems(selectedWrapper) {
  if (bundleStyle !== 'DEFAULT') {
    return getNewPatternCartItems();
  }
  const arr = [];
  const selectedOptionsValuesFromActiveTier =
    getSelectedOptionsValueFromActiveTier(selectedWrapper);
  const selectedOptionsValuesFromActiveTierCount = getVariantsSelectedCount(
    selectedOptionsValuesFromActiveTier,
  );
  Object.entries(selectedOptionsValuesFromActiveTierCount).forEach(
    ([key, value]) => {
      arr.push({
        id: key,
        quantity: value,
      });
    },
  );

  return arr;
}

function handleOfferRadioChange(event) {
  document.querySelectorAll(".aom-discount-wrapper").forEach((el) => {
    el.classList.remove("aom-discount-active");
  });

  const selectedWrapper = event.target.closest(".aom-discount-wrapper");
  selectedWrapper.classList.add("aom-discount-active");
  const selectedOptionValues = getSelectedOptionsIdFromActiveTier(
    selectedWrapper,
    event,
  );

  if (widget.dataset.aomHasOnlyDefaultVariant != "true") {
    // eslint-disable-next-line no-undef
    preserveWindowScroll(function () {
      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target: selectedWrapper.querySelectorAll("select")[0].options[0],
          selectedOptionValues,
        },
      });
    });
    updateProductPresentationForVariant(findMatchingVariant(
      getSelectedOptionsValueFromEventGroup(selectedWrapper, event),
    ));
  }

  const { quantity, discountValue, discountType } = event.target.dataset;
  updatePrices(
    selectedWrapper,
    parseInt(quantity),
    discountValue,
    discountType,
  );
  aomTrackSafe('aom_bundle_tier_select', {
    ui_element: 'bundle_widget',
    action_type: 'tier_select',
    bundle_quantity: quantity,
    discount_value: discountValue,
    discount_type: discountType,
  });
}

function handleSelectChange(event) {
  const selectedWrapper = event.target.closest(".aom-discount-wrapper");
  const selectedOptionValues = getSelectedOptionsIdFromActiveTier(
    selectedWrapper,
    event,
  );

  if (widget.dataset.aomHasOnlyDefaultVariant != "true") {
    // eslint-disable-next-line no-undef
    preserveWindowScroll(function () {
      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target: event.target,
          selectedOptionValues,
        },
      });
    });
    updateProductPresentationForVariant(findMatchingVariant(
      getSelectedOptionsValueFromEventGroup(selectedWrapper, event),
    ));
  }

  const offerRaw = selectedWrapper.querySelector(".aom-discount-radio");
  const { quantity, discountValue, discountType } = offerRaw.dataset;

  updatePrices(
    selectedWrapper,
    parseInt(quantity),
    discountValue,
    discountType,
  );
}

// Attach to all discount tier radios
document.querySelectorAll(".aom-discount-radio").forEach((radio) => {
  radio.addEventListener("change", handleOfferRadioChange);
});

// Attach to all select elements
document.querySelectorAll(".aom-discount-select").forEach((select) => {
  select.addEventListener("change", handleSelectChange);
});

function formListenerWithRetry(attempt = 0) {
  const form = document.querySelector('product-form form[action$="/cart/add"]');

  if (form) {
    form.addEventListener(
      "submit",
      (evt) => {
        evt.preventDefault();
        evt.stopImmediatePropagation();

        const productForm = form.closest("product-form");
        const submitButton = productForm.querySelector('[type="submit"]');

        if (submitButton.getAttribute("aria-disabled") === "true") return;

        productForm.handleErrorMessage();
        submitButton.setAttribute("aria-disabled", "true");
        submitButton.classList.add("loading");
        productForm
          .querySelector(".loading__spinner")
          .classList.remove("hidden");

        const cartElement =
          document.querySelector("cart-drawer") ||
          document.querySelector("cart-notification");

        const formData = new FormData();
        const wrapper = document.querySelector(
          ".aom-discount-wrapper.aom-discount-active",
        );
        const items = getCartItems(wrapper);

        aomTrackSafe('aom_bundle_add_to_cart', {
          ui_element: 'bundle_widget',
          action_type: 'add_to_cart',
          item_count: items.length,
        });

        items.forEach((item, index) => {
          formData.append(`items[${index}][id]`, item.id);
          formData.append(`items[${index}][quantity]`, item.quantity);
        });

        if (cartElement) {
          let sectionIds = [];
          if (typeof cartElement.getSectionsToRender === "function") {
            sectionIds = cartElement
              .getSectionsToRender()
              .map((section) => section.id);
          } else {
            // Fallback: Manually add the cart element's ID and any other key sections.
            // The cart element's own ID is the most common one to update.
            if (cartElement.id) {
              sectionIds.push(cartElement.id);
            }
            // Also, find the header's cart icon bubble section, as that usually needs updating.
            const cartIconBubble = document.querySelector("#cart-icon-bubble");
            if (cartIconBubble) {
              const headerSection = cartIconBubble.closest(".shopify-section");
              if (headerSection && headerSection.id) {
                sectionIds.push(headerSection.id);
              }
            }
          }

          // Add the gathered section IDs and the current URL to the form data.
          if (sectionIds.length > 0) {
            formData.append("sections", [...new Set(sectionIds)].join(",")); // Use Set to remove duplicates
            formData.append("sections_url", window.location.pathname);
          }
        }

        // --- SEND THE MODIFIED FETCH REQUEST ---
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((datax) => {
            const data = {
              key: datax.items[0].key,
              ...datax,
            };
            if (data.status) {
              productForm.handleErrorMessage(
                data.description || "An error occurred.",
              );
              return;
            }

            if (cartElement && data.sections) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                cartData: data,
              });
              cartElement.renderContents(data);
            } else {
              window.location.href = window.Shopify.routes.root + "cart";
            }
          })
          .catch((err) => {
            productForm.handleErrorMessage(err.message || "An error occurred.");
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            if (cartElement?.classList.contains("is-empty")) {
              cartElement.classList.remove("is-empty");
            }
            submitButton.removeAttribute("aria-disabled");
            productForm
              .querySelector(".loading__spinner")
              .classList.add("hidden");
          });
      },
      { capture: true },
    );
  } else if (attempt < 20) {
    setTimeout(() => formListenerWithRetry(attempt + 1), 100);
  } else {
    console.error("Could not find the product-form to attach bundle listener.");
  }
}

formListenerWithRetry();
function initCountdownTimers() {
  const timers = document.querySelectorAll(".aom-urgency-countdown");
  if (!timers.length) return;

  const update = () => {
    const now = new Date();
    timers.forEach((timer) => {
      const cutoffTime = timer.dataset.cutoffTime;
      const expiredText = timer.dataset.expiredText;
      const templateText = timer.dataset.timerText;

      if (!cutoffTime) return;

      const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(cutoffTime);
      if (!match) return;
      const hours = Number(match[1]);
      const minutes = Number(match[2]);
      let target = new Date();
      target.setHours(hours, minutes, 0, 0);

      let diff = target - now;

      if (diff < 0) {
        if (expiredText) {
          timer.textContent = expiredText;
          timer.style.display = "";
        } else {
          const container = timer.closest(".aom-bundle-pulse-container");
          if (container) container.style.display = "none";
        }
      } else {
         const twelveHoursMs = 12 * 60 * 60 * 1000;
         if (diff > twelveHoursMs) {
             diff -= twelveHoursMs;
         }

         const twoHoursMs = 2 * 60 * 60 * 1000;
         if (diff < twoHoursMs) {
             timer.style.color = "#D72C0D";
         } else {
             timer.style.color = "";
         }

         const h = Math.floor(diff / (1000 * 60 * 60));
         const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
         const s = Math.floor((diff % (1000 * 60)) / 1000);

         const { hr, mins, secs } = currentTranslation;
         let timeString = "";

         if (h > 0) {
             timeString = `${h} ${hr} ${m} ${mins}`;
         } else {
             timeString = `${m} ${mins} ${s} ${secs}`;
         }

         if (templateText) {
             timer.textContent = templateText.replace(/\{\{\s*timer_countdown\s*\}\}/gi, timeString).replace(/\{\{\s*time\s*\}\}/gi, timeString);
         } else {
             timer.textContent = timeString;
         }

         const container = timer.closest(".aom-bundle-pulse-container");
         if (container) container.style.display = "";
      }
    });
  };

  update();
  setInterval(update, 1000);
}

initCountdownTimers();

// ─────────────────────────────────────────────────────────────────────────────
// NEW PATTERN SUPPORT — PATTERN_A (Tile List) and PATTERN_B (Segmented Control)
// ─────────────────────────────────────────────────────────────────────────────

// Module-level state for new patterns (hoisted so getCartItems can reference)
var _aomSelIdx = 0;
var _aomUnitStates = [];
// Per-tier saved selections, keyed by tier index. The round-robin spread runs
// once per tier (first open); after that we restore whatever the shopper last
// had, so switching tiers back and forth never re-picks their variants.
var _aomUnitStatesByTier = {};
var AOM_BUNDLE_CHECK_ICON_URL = 'https://cdn.shopify.com/s/files/1/0621/4932/9122/files/check_28217dc2-7334-4606-a278-a626c55cd88b.svg';

// Called from getCartItems when bundleStyle !== 'DEFAULT'
function getNewPatternCartItems() {
  var result = [];
  _aomUnitStates.forEach(function (state) {
    var v = findMatchingVariant(state.optionValues);
    if (!v) return;
    var id = String(v.id);
    var existing = result.find(function (item) { return item.id === id; });
    if (existing) { existing.quantity++; } else { result.push({ id: id, quantity: 1 }); }
  });
  return result;
}

if (bundleStyle !== 'DEFAULT') {
  var _bOffers = JSON.parse((document.getElementById('aom-bundle-offers-json') || {}).textContent || '[]');
  var _tierNotes = JSON.parse((document.getElementById('aom-bundle-tier-notes') || {}).textContent || '[]');
  var _swCfg = JSON.parse((document.getElementById('aom-bundle-swatch-config') || {}).textContent || 'null');
  var _pOpts = JSON.parse((document.getElementById('aom-bundle-product-options') || {}).textContent || '[]');
  var _hasOnlyDefault = widget && widget.dataset.aomHasOnlyDefaultVariant === 'true';
  var _selectedVariantOptions = [];
  try {
    _selectedVariantOptions = JSON.parse(widget?.dataset.aomSelectedOptions || '[]');
  } catch (e) {
    _selectedVariantOptions = [];
  }

  var _swatchApi = window.AOMVariantSwatch || {};
  if (!_swatchApi.createPill || !_swatchApi.normalizeOptionEntries) {
    console.error('[AOM Bundle] Variant swatch component is unavailable.');
  }

  var _swOptions = _swatchApi.normalizeOptionEntries ? _swatchApi.normalizeOptionEntries(_swCfg, _pOpts) : [];
  var _handledOptIdxs = _swOptions.map(function (o) { return o.index; });

  // ── Price helpers ──────────────────────────────────────────────────────────
  function _getPriceInfo(offer, tierIndex) {
    // Price each bundle unit by its own selected variant (swatches let units
    // differ), so per-variant/market pricing is reflected. Fall back to the
    // default variant × quantity when unit states aren't available yet.
    var baseCents = 0;
    var priceCents = 0;
    var images = [];
    var titles = [];
    var states = (tierIndex != null) ? _getOrInitUnitStates(tierIndex, offer.quantity) : null;
    if (states && states.length) {
      states.forEach(function (st) {
        var v = findMatchingVariant(st.optionValues) || productVariants[0];
        if (!v) return;
        baseCents += getBasePriceCents(v);
        priceCents += getCurrentPriceCents(v);
        var src = getImageSrc(getVariantFeaturedImage(v));
        if (src && images.indexOf(src) === -1) images.push(src);
        titles.push(v.title);
      });
    } else {
      var ref = findMatchingVariant(_getDefaultSels()) || productVariants[0];
      if (!ref) return { priceCents: 0, saveCents: 0, origCents: 0, images: [], titles: [] };
      baseCents = getBasePriceCents(ref) * offer.quantity;
      priceCents = getCurrentPriceCents(ref) * offer.quantity;
      var refSrc = getImageSrc(getVariantFeaturedImage(ref));
      if (refSrc) images.push(refSrc);
      titles.push(ref.title);
    }
    if (offer.discountType === 'PERCENTAGE_DISCOUNT') {
      var pct = Math.max(0, Math.min(100, parseFloat(offer.value || 0)));
      priceCents = Math.round(priceCents * (100 - pct) / 100);
    }
    return { priceCents: priceCents, saveCents: Math.max(0, baseCents - priceCents), origCents: baseCents, images: images, titles: titles };
  }

  // Re-render tier prices + active-tier header after a swatch pick, so a
  // variant with a different price updates the displayed amount immediately.
  function _refreshPrices() {
    if (bundleStyle === 'PATTERN_A') _syncPatternAPrices();
    else if (bundleStyle === 'PATTERN_B') _syncPatternBPrices();
    var offer = _bOffers[_aomSelIdx];
    if (!offer) return;
    var info = _getPriceInfo(offer, _aomSelIdx);
    dispatchSavings({ saveCents: info.saveCents, priceCents: info.priceCents, origCents: info.origCents, quantity: offer.quantity, images: info.images, titles: info.titles, label: offer.title || null });
    var priceEl = document.getElementById('aom-ds-price');
    var saveEl = document.getElementById('aom-ds-save');
    if (priceEl) priceEl.textContent = formatMoney(info.priceCents);
    if (saveEl) {
      saveEl.textContent = info.saveCents > 0 ? currentTranslation.save + ' ' + formatMoney(info.saveCents) : '';
      saveEl.hidden = info.saveCents <= 0;
    }
  }

  function _getDefaultSels() {
    if (_selectedVariantOptions.length) return _selectedVariantOptions.slice();
    return (productVariants[0] && productVariants[0].options) ? productVariants[0].options.slice() : [];
  }

  // Build one state per bundle unit. Instead of defaulting every unit to the
  // same variant, round-robin the primary swatch option's values across units
  // (unit 0 keeps the shopper's current selection, each next item advances one
  // value, wrapping around). Falls back to the default value if the resulting
  // combination isn't a real variant.
  function _buildInitialUnitStates(qty) {
    var defaultSels = _getDefaultSels();
    var primary = _swOptions.length ? _swOptions[0] : null;
    var values = primary && primary.values ? primary.values : [];

    var startIdx = 0;
    if (primary && defaultSels[primary.index] != null) {
      var found = values.findIndex(function (v) { return v.label === defaultSels[primary.index]; });
      if (found >= 0) startIdx = found;
    }

    var states = [];
    for (var u = 0; u < qty; u++) {
      var vals = defaultSels.slice();
      if (primary && values.length > 1) {
        var pick = values[(startIdx + u) % values.length];
        if (pick) {
          var candidate = vals.slice();
          candidate[primary.index] = pick.label;
          if (findMatchingVariant(candidate)) vals = candidate;
        }
      }
      states.push({ optionValues: vals });
    }
    return states;
  }

  // Return the saved states for a tier, or build (and cache) the initial spread
  // the first time it's opened. The same array reference is reused, so pill
  // picks (which mutate _aomUnitStates) persist across tier switches.
  function _getOrInitUnitStates(tierIndex, qty) {
    var cached = _aomUnitStatesByTier[tierIndex];
    if (cached && cached.length === qty) return cached;
    var fresh = _buildInitialUnitStates(qty);
    _aomUnitStatesByTier[tierIndex] = fresh;
    return fresh;
  }

  function _getInitialOfferIndex() {
    var idx = _bOffers.findIndex(function (offer) { return offer && offer.isDefault; });
    return idx >= 0 ? idx : 0;
  }

  function _escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = String(value || '');
    return div.innerHTML;
  }

  // ── Unit completeness ──────────────────────────────────────────────────────
  function _isUnitComplete(u) {
    if (_hasOnlyDefault || !_handledOptIdxs.length) return true;
    return _handledOptIdxs.every(function (i) {
      return _aomUnitStates[u] && _aomUnitStates[u].optionValues[i] != null;
    });
  }

  function _checkIconHtml(className, alt) {
    return '<img class="' + className + '" src="' + AOM_BUNDLE_CHECK_ICON_URL + '" alt="' + (alt || '') + '" loading="lazy" decoding="async">';
  }

  function _setUnitIndicator(el, index, done) {
    if (!el) return;
    if (done) {
      el.innerHTML = _checkIconHtml('aom-unit-check-icon', 'Done');
    } else {
      el.textContent = String(index + 1);
    }
  }

  // The size guide dialog is rendered by aom-variant-swatch.liquid outside the
  // picker the bundle hides; variant-swatch.js opens any [data-aom-sg-open].
  // optIdx null means "whichever option the guide is for".
  function _sizeGuideButton(optIdx) {
    var wrap = document.getElementById('aom-configure-wrap');
    var scope = (wrap && wrap.closest('.shopify-section')) || document;
    var dlg = scope.querySelector('dialog.aom-sg[data-aom-sg-option]');
    if (!dlg) return null;
    var guideOpt = Number(dlg.getAttribute('data-aom-sg-option'));
    if (optIdx != null && guideOpt !== optIdx) return null;
    if (!_swOptions.some(function (o) { return o.index === guideOpt; })) return null;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'aom-sw-guide';
    btn.setAttribute('data-aom-sg-open', dlg.id);
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.textContent = dlg.getAttribute('data-aom-sg-label') || 'Size guide';
    return btn;
  }

  function _createPill(u, optIdx, valCfg, type, selectedVal) {
    var pill = _swatchApi.createPill({
      type: type,
      value: valCfg,
      optionIndex: optIdx,
      selected: valCfg.label === selectedVal,
      dataset: {
        aomBundleUnit: String(u),
        aomBundleOptionIndex: String(optIdx),
      },
    });
    pill.addEventListener('click', function () { _pick(u, optIdx, valCfg.label); });
    return pill;
  }

  // ── Chips (unit header summary) ────────────────────────────────────────────
  function _renderChips(u) {
    var el = document.getElementById('aom-chips-' + u);
    if (!el) return;
    var vals = _aomUnitStates[u] ? _aomUnitStates[u].optionValues : [];
    var parts = _handledOptIdxs.filter(function (i) { return vals[i] != null; }).map(function (i) {
      return _escapeHtml(vals[i]);
    });
    el.textContent = parts.join(' / ');
  }

  // ── Unit accordion open/close ──────────────────────────────────────────────
  // Units are independently collapsible: toggling one does not affect the
  // others (they all start open — see _buildUnitCard).
  function _toggleUnit(u) {
    var card = document.getElementById('aom-unit-' + u);
    if (!card) return;
    if (card.classList.contains('aom-active')) {
      card.classList.remove('aom-active');
      if (_isUnitComplete(u)) {
        card.classList.add('aom-done');
        _setUnitIndicator(document.getElementById('aom-unum-' + u), u, true);
      }
    } else {
      card.classList.add('aom-active');
      card.classList.remove('aom-done');
    }
  }

  // Expose globally for inline onclick attributes
  window._aomToggleUnit = _toggleUnit;

  // ── Progress bar ───────────────────────────────────────────────────────────
  function _updateProgress() {
    var total = _aomUnitStates.length;
    var done = _aomUnitStates.filter(function (_, i) { return _isUnitComplete(i); }).length;
    var fill = document.getElementById('aom-prog-fill');
    var text = document.getElementById('aom-prog-text');
    if (fill) fill.style.width = (total ? (done / total * 100) : 0) + '%';
    if (text) {
      if (done === total) {
        text.innerHTML = 'All items configured ' + _checkIconHtml('aom-progress-check-icon', '');
      } else {
        text.textContent = done + ' of ' + total + ' items configured';
      }
    }
  }

  // ── Tier note hint ────────────────────────────────────────────────────────
  function _updateHint(idx) {
    var hint = document.getElementById('aom-tier-note');
    var text = document.getElementById('aom-tier-note-text');
    var note = (_tierNotes[idx] || '').trim();
    if (!hint) return;
    if (note) {
      if (text) text.textContent = note;
      hint.style.display = '';
    } else {
      hint.style.display = 'none';
    }
  }

  // ── Pick a pill value ──────────────────────────────────────────────────────
  function _pick(u, optIdx, val) {
    if (!_aomUnitStates[u]) return;
    _aomUnitStates[u].optionValues[optIdx] = val;

    // Update pill visual state in both shared picker and unit cards
    document.querySelectorAll('.aom-sw-pill[data-aom-bundle-unit="' + u + '"][data-aom-bundle-option-index="' + optIdx + '"]').forEach(function (p) {
      var active = p.dataset.aomSwVal === val;
      p.classList.toggle('is-selected', active);
      p.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    _renderChips(u);
    _updateProgress();
    _refreshPrices();

    // Preview whichever bundle item the customer is actively configuring.
    if (!_hasOnlyDefault) {
      updateProductPresentationForVariant(findMatchingVariant(_aomUnitStates[u].optionValues));
    }

    // Auto-advance disabled — leave cards in their current open/closed state
  }

  // ── Shared picker (qty === 1) ──────────────────────────────────────────────
  function _renderSharedPicker() {
    var container = document.getElementById('aom-shared-picker');
    if (!container) return;
    container.innerHTML = '';
    if (!_swOptions.length) return;
    _swOptions.forEach(function (optCfg) {
      var optIdx = optCfg.index;
      var optName = _pOpts[optIdx] ? _pOpts[optIdx].name : ('Option ' + (optIdx + 1));
      var selectedVal = _aomUnitStates[0] ? _aomUnitStates[0].optionValues[optIdx] : null;

      var group = document.createElement('div');
      group.className = 'aom-sw-group aom-bundle-sw-group';

      var label = document.createElement('div');
      label.className = 'aom-bundle-sw-label';
      label.textContent = optName;
      var guideBtn = _sizeGuideButton(optIdx);
      if (guideBtn) {
        label.classList.add('aom-has-guide');
        label.appendChild(guideBtn);
      }
      group.appendChild(label);

      var row = document.createElement('div');
      row.className = 'aom-sw-pills';
      row.setAttribute('role', 'listbox');
      row.setAttribute('aria-label', optName);

      var rowType = optCfg.compactType || optCfg.type;
      if (_swatchApi.decorateRow) _swatchApi.decorateRow(row, rowType, optCfg.values.length);
      optCfg.values.forEach(function (valCfg) {
        var pill = _createPill(0, optIdx, valCfg, rowType, selectedVal);
        row.appendChild(pill);
      });

      group.appendChild(row);
      container.appendChild(group);
    });
  }

  // ── Build a unit card (closed row + open card) ────────────────────────────
  function _makeSvgChevron(cls, size, pointsUp) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', cls);
    svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    svg.setAttribute('width', String(size));
    svg.setAttribute('height', String(size));
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2.5');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    var poly = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
    poly.setAttribute('points', pointsUp ? '6 15 12 9 18 15' : '6 9 12 15 18 9');
    svg.appendChild(poly);
    return svg;
  }

  function _buildUnitCard(u) {
    var card = document.createElement('div');
    card.id = 'aom-unit-' + u;
    card.className = 'aom-unit-card aom-active';

    // ── Closed row ────────────────────────────────────────────────
    var closed = document.createElement('div');
    closed.className = 'aom-unit-closed';
    closed.addEventListener('click', function () { _toggleUnit(u); });

    var ucLeft = document.createElement('div');
    ucLeft.className = 'aom-uc-left';

    var ucIndex = document.createElement('div');
    ucIndex.className = 'aom-uc-index';
    ucIndex.textContent = (u + 1) + '.';

    var ucValues = document.createElement('div');
    ucValues.className = 'aom-uc-values';
    ucValues.id = 'aom-chips-' + u;

    ucLeft.appendChild(ucIndex);
    ucLeft.appendChild(ucValues);
    closed.appendChild(ucLeft);
    closed.appendChild(_makeSvgChevron('aom-uc-chev', 11, false));

    // ── Open card ─────────────────────────────────────────────────
    var open = document.createElement('div');
    open.className = 'aom-unit-open';

    var openHeader = document.createElement('div');
    openHeader.className = 'aom-unit-open-header';
    openHeader.addEventListener('click', function () { _toggleUnit(u); });

    var firstOptName = _swOptions.length > 0 && _pOpts[_swOptions[0].index]
      ? _pOpts[_swOptions[0].index].name
      : 'Option 1';

    var uoLabel = document.createElement('div');
    uoLabel.className = 'aom-uo-label';
    uoLabel.textContent = (u + 1) + ' · ' + firstOptName;

    openHeader.appendChild(uoLabel);
    openHeader.appendChild(_makeSvgChevron('aom-uo-chev', 11, true));
    open.appendChild(openHeader);

    var openBody = document.createElement('div');
    openBody.className = 'aom-unit-open-body';

    _swOptions.forEach(function (optCfg, loopIdx) {
      var optIdx = optCfg.index;
      var optName = _pOpts[optIdx] ? _pOpts[optIdx].name : ('Option ' + (optIdx + 1));
      var selectedVal = _aomUnitStates[u] ? _aomUnitStates[u].optionValues[optIdx] : null;

      var row = document.createElement('div');
      row.className = 'aom-sw-pills';
      row.setAttribute('role', 'listbox');
      row.setAttribute('aria-label', optName);
      row.dataset.u = String(u);
      row.dataset.oi = String(optIdx);

      var rowType = optCfg.compactType || optCfg.type;
      if (_swatchApi.decorateRow) _swatchApi.decorateRow(row, rowType, optCfg.values.length);
      optCfg.values.forEach(function (valCfg) {
        var pill = _createPill(u, optIdx, valCfg, rowType, selectedVal);
        row.appendChild(pill);
      });

      if (loopIdx === 0) {
        row.classList.add('aom-first-pills');
        openBody.appendChild(row);
      } else {
        var vsec = document.createElement('div');
        vsec.className = 'aom-vsec';
        var vlabel = document.createElement('div');
        vlabel.className = 'aom-vlabel';
        vlabel.textContent = optName;
        vsec.appendChild(vlabel);
        vsec.appendChild(row);
        openBody.appendChild(vsec);
      }
    });

    open.appendChild(openBody);
    card.appendChild(closed);
    card.appendChild(open);
    return card;
  }

  // ── Update configure section when tier changes ─────────────────────────────
  function _updateConfigSection(qty) {
    var wrap = document.getElementById('aom-configure-wrap');
    if (!wrap) return;

    if (_hasOnlyDefault || !_swOptions.length) {
      wrap.style.display = 'none';
      return;
    }

    wrap.style.display = '';
    wrap.innerHTML = '';

    if (qty === 1) {
      // Single item: inline configure inside the selected tile
      wrap.className = 'aom-configure-wrap';

      var picker = document.createElement('div');
      picker.id = 'aom-shared-picker';
      picker.className = 'aom-shared-picker';
      wrap.appendChild(picker);
      _renderSharedPicker();

    } else {
      // Multi item: gray card below tiles
      wrap.className = 'aom-configure-wrap aom-configure-multi';

      var card = document.createElement('div');
      card.className = 'aom-configure-card';

      var cardHdr = document.createElement('div');
      cardHdr.className = 'aom-configure-card-header';
      cardHdr.id = 'aom-config-label';
      var selectionTextEl = document.getElementById('aom-bundle-selection-text');
      var selectionTextTpl = selectionTextEl ? JSON.parse(selectionTextEl.textContent || '') : 'Configure your {count} items';
      cardHdr.textContent = selectionTextTpl.replace('{count}', qty);
      // One guide link for the whole card, not one per unit: the first option
      // in a unit card has no label row to carry it.
      var cardGuideBtn = _sizeGuideButton(null);
      if (cardGuideBtn) {
        cardHdr.classList.add('aom-has-guide');
        cardHdr.appendChild(cardGuideBtn);
      }
      card.appendChild(cardHdr);

      var hint = document.createElement('div');
      hint.className = 'aom-hint';
      hint.id = 'aom-tier-note';
      hint.style.display = 'none';
      var hintDot = document.createElement('div');
      hintDot.className = 'aom-hint-dot';
      var hintSpan = document.createElement('span');
      hintSpan.id = 'aom-tier-note-text';
      hint.appendChild(hintDot);
      hint.appendChild(hintSpan);
      card.appendChild(hint);

      var unitsDiv = document.createElement('div');
      unitsDiv.className = 'aom-configure-units';
      unitsDiv.id = 'aom-units-container';

      for (var u = 0; u < qty; u++) {
        unitsDiv.appendChild(_buildUnitCard(u));
      }

      card.appendChild(unitsDiv);
      wrap.appendChild(card);

      // Chips must be called after elements are in the DOM (getElementById needs them attached)
      for (var unitIndex = 0; unitIndex < qty; unitIndex++) {
        _renderChips(unitIndex);
      }
    }
  }

  // ── PATTERN A: Tile List ───────────────────────────────────────────────────
  function _initPatternA() {
    var wrap = document.getElementById('aom-btile-wrap');
    if (!wrap || !_bOffers.length) return;

    var initialIndex = _getInitialOfferIndex();
    wrap.querySelectorAll('.aom-btile').forEach(function (tile) {
      var idx = parseInt(tile.dataset.aomTierIndex || '0', 10);
      tile.addEventListener('click', function () { _selectTileA(idx); });
    });
    _syncPatternAPrices();

    _selectTileA(initialIndex);
  }

  function _syncPatternAPrices() {
    document.querySelectorAll('.aom-btile').forEach(function (tile) {
      var idx = parseInt(tile.dataset.aomTierIndex || '0', 10);
      var offer = _bOffers[idx];
      if (!offer) return;
      var info = _getPriceInfo(offer, idx);
      var priceEl = tile.querySelector('[data-aom-role="price"]');
      var originalEl = tile.querySelector('[data-aom-role="original-price"]');
      var savingsEl = tile.querySelector('[data-aom-role="savings"]');
      var eachEl = tile.querySelector('[data-aom-role="each-price"]');
      if (priceEl) priceEl.textContent = formatMoney(info.priceCents);
      if (originalEl) {
        originalEl.textContent = info.saveCents > 0 ? formatMoney(info.origCents) : '';
        originalEl.hidden = info.saveCents <= 0;
      }
      if (savingsEl) {
        if (info.saveCents > 0) {
          savingsEl.textContent = currentTranslation.save + ' ' + formatMoney(info.saveCents);
          savingsEl.style.display = '';
        } else {
          savingsEl.textContent = '';
          savingsEl.style.display = 'none';
        }
      }
      if (eachEl && offer.quantity > 0) {
        eachEl.textContent = formatMoney(Math.round(info.priceCents / offer.quantity)) + ' ' + currentTranslation.each;
      }
    });
  }

  function _selectTileA(ti) {
    _aomSelIdx = ti;
    var offer = _bOffers[ti];
    var info = _getPriceInfo(offer, ti);
    dispatchSavings({ saveCents: info.saveCents, priceCents: info.priceCents, origCents: info.origCents, quantity: offer.quantity, images: info.images, titles: info.titles, label: offer.title || null });
    document.querySelectorAll('.aom-btile').forEach(function (t, i) {
      var idx = parseInt(t.dataset.aomTierIndex || String(i), 10);
      var selected = idx === ti;
      t.classList.toggle('aom-sel', selected);
      t.setAttribute('aria-pressed', selected ? 'true' : 'false');
      var dot = t.querySelector('.aom-bdot');
      if (dot) dot.style.opacity = selected ? '1' : '0';
    });

    // Place configure-wrap: inside tile for qty=1, after tile list for qty>1
    var configWrap = document.getElementById('aom-configure-wrap');
    if (configWrap) {
      if (offer.quantity === 1) {
        var selectedItem = document.querySelector('.aom-btile-item[data-aom-tier-item="' + ti + '"]');
        if (selectedItem) selectedItem.appendChild(configWrap);
      } else {
        var tilesWrap = document.getElementById('aom-btile-wrap');
        if (tilesWrap && tilesWrap.parentNode) {
          tilesWrap.parentNode.insertBefore(configWrap, tilesWrap.nextSibling);
        }
      }
    }

    _aomUnitStates = _getOrInitUnitStates(ti, offer.quantity);
    _updateConfigSection(offer.quantity);
    _updateHint(ti);

    aomTrackSafe('aom_bundle_tier_select', {
      ui_element: 'bundle_widget',
      action_type: 'tier_select',
      bundle_quantity: offer.quantity,
      discount_value: offer.value,
      discount_type: offer.discountType,
    });
  }

  // ── PATTERN B: Segmented Control ───────────────────────────────────────────
  function _initPatternB() {
    var seg = document.getElementById('aom-seg');
    if (!seg || !_bOffers.length) return;

    var initialIndex = _getInitialOfferIndex();
    seg.querySelectorAll('.aom-sbtn').forEach(function (btn) {
      var idx = parseInt(btn.dataset.aomTierIndex || '0', 10);
      btn.addEventListener('click', function () { _selectSegB(idx); });
    });
    _syncPatternBPrices();

    _selectSegB(initialIndex);
  }

  function _syncPatternBPrices() {
    document.querySelectorAll('.aom-sbtn').forEach(function (btn) {
      var idx = parseInt(btn.dataset.aomTierIndex || '0', 10);
      var offer = _bOffers[idx];
      if (!offer) return;
      var info = _getPriceInfo(offer, idx);
      var priceEl = btn.querySelector('[data-aom-role="price"]');
      var savingsEl = btn.querySelector('[data-aom-role="savings"]');
      var eachEl = btn.querySelector('[data-aom-role="each-price"]');
      if (priceEl) priceEl.textContent = formatMoney(info.priceCents);
      if (savingsEl) {
        savingsEl.textContent = info.saveCents > 0 ? currentTranslation.save + ' ' + formatMoney(info.saveCents) : '';
        savingsEl.hidden = info.saveCents <= 0;
      }
      if (eachEl && offer.quantity > 0) eachEl.textContent = formatMoney(Math.round(info.priceCents / offer.quantity)) + ' ' + currentTranslation.each;
    });
  }

  function _selectSegB(idx) {
    _aomSelIdx = idx;
    var offer = _bOffers[idx];
    var info = _getPriceInfo(offer, idx);
    dispatchSavings({ saveCents: info.saveCents, priceCents: info.priceCents, origCents: info.origCents, quantity: offer.quantity, images: info.images, titles: info.titles, label: offer.title || null });

    document.querySelectorAll('.aom-sbtn').forEach(function (b, i) {
      var btnIdx = parseInt(b.dataset.aomTierIndex || String(i), 10);
      var selected = btnIdx === idx;
      b.classList.toggle('aom-sel', selected);
      b.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    var labelEl = document.getElementById('aom-ds-label');
    var priceEl = document.getElementById('aom-ds-price');
    var saveEl = document.getElementById('aom-ds-save');
    if (labelEl) labelEl.textContent = offer.title || (offer.quantity + ' item' + (offer.quantity > 1 ? 's' : ''));
    if (priceEl) priceEl.textContent = formatMoney(info.priceCents);
    if (saveEl) {
      saveEl.textContent = info.saveCents > 0 ? currentTranslation.save + ' ' + formatMoney(info.saveCents) : '';
      saveEl.hidden = info.saveCents <= 0;
    }

    _aomUnitStates = _getOrInitUnitStates(idx, offer.quantity);
    _updateConfigSection(offer.quantity);
    _updateHint(idx);

    aomTrackSafe('aom_bundle_tier_select', {
      ui_element: 'bundle_widget',
      action_type: 'tier_select',
      bundle_quantity: offer.quantity,
      discount_value: offer.value,
      discount_type: offer.discountType,
    });
  }

  // ── Initialize ─────────────────────────────────────────────────────────────
  if (bundleStyle === 'PATTERN_A') {
    _initPatternA();
  } else if (bundleStyle === 'PATTERN_B') {
    _initPatternB();
  }
}
